import { render, staticRenderFns } from "./production-summary.vue?vue&type=template&id=420d8d1e&scoped=true&"
import script from "./production-summary.js?vue&type=script&lang=js&"
export * from "./production-summary.js?vue&type=script&lang=js&"
import style0 from "./production-summary.scss?vue&type=style&index=0&id=420d8d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d8d1e",
  null
  
)

export default component.exports